module.exports = __webpack_public_path__ + "media/images/logo-only-a56befd4515cdf54287ae83396b08c78.svg";